import type {ShippingRate} from "@/stores/cartStore";

export const NEXT_DAY_RATE_CODES = ["table_rates-1241", "table_rates-1251"];
export const SECOND_DAY_RATE_CODES = ["table_rates-1240", "table_rates-1250"];
export const NEXT_DAY_RATE_NAMES = ["Next Day Shipping"];
export const SECOND_DAY_RATE_NAMES = ["Second Day Shipping"];

const NEXT_DAY_DELIVERY_DAYS = 1;
const SECOND_DAY_DELIVERY_DAYS = 2;

const normalize = (value: string | null | undefined) => (value || "").trim().toLowerCase();

const matchesRate = (rate: ShippingRate, codes: string[], names: string[]) => {
  const code = normalize(rate.code);
  if(code && codes.some(i => normalize(i) === code)) {
    return true;
  }

  return names.some(i => {
    const name = normalize(i);
    return Boolean(name) && (name === normalize(rate.name) || name === normalize(rate.presentment_name));
  });
};

export const isNextDayRate = (rate: ShippingRate) => matchesRate(rate, NEXT_DAY_RATE_CODES, NEXT_DAY_RATE_NAMES);
export const isSecondDayRate = (rate: ShippingRate) => matchesRate(rate, SECOND_DAY_RATE_CODES, SECOND_DAY_RATE_NAMES);

export const getDeliveryDays = (rate: ShippingRate) => Array.isArray(rate.delivery_days) ? rate.delivery_days.filter(day => typeof day === "number") : [];

export const hasDeliveryDaysEstimate = (rate: ShippingRate) => getDeliveryDays(rate).length > 0;

export const hasFixedDeliveryDays = (rate: ShippingRate, days: number) => {
  const deliveryDays = getDeliveryDays(rate);

  return deliveryDays.length > 0 && deliveryDays.every(day => day === days);
};

const isBelowTransitTime = (rate: ShippingRate, transitDays: number) => {
  const deliveryDays = getDeliveryDays(rate);

  return deliveryDays.length > 0 && deliveryDays.every(day => day < transitDays);
};

export const hasStaleExpressRates = (rates: ShippingRate[]) => rates.some(rate =>
  isNextDayRate(rate) && isBelowTransitTime(rate, NEXT_DAY_DELIVERY_DAYS) ||
  isSecondDayRate(rate) && isBelowTransitTime(rate, SECOND_DAY_DELIVERY_DAYS)
);
